import React from 'react'
import Dashboard from '../../componente/dashboard/index.jsx';
import { useAppContext } from '../../context/AppContext.js';
import "./style.css";

function Principal() {
    const { companies, selectedCompany, codassinante, accessKey } = useAppContext(); 

    return <>
        <div className="app-container">        
            <Dashboard />
        </div>
    </>
}

export default Principal;